import { TypographySelectValue } from '@makyoapp/makyo-common'
import { CircularProgress, ColorVariant, RawSpacingInput } from '@makyoapp/makyo-tw-ui'

export interface CompCircularProgressProps {
  maxValue: number | undefined
  currentValue: number | undefined
  indeterminate: boolean
  size: string
  compAlignment: string
  activeIndicatorColor: string
  trackColor: string
  margin: RawSpacingInput
  labelTypography: TypographySelectValue
  showValue: boolean
  heading: string
  headingAlignment: string
  titleComponent: React.ReactNode
  textColor: string
  valueColorType: 'adaptive' | 'solid' | 'gradient'
  valueColorSolid: ColorVariant
  valueColorStartGradient: ColorVariant
  valueColorEndGradient: ColorVariant
  valueColorGradientDirection: string
  backgroundColor: ColorVariant
  circleColorType: 'adaptive' | 'solid' | 'gradient'
  circleColorSolid: ColorVariant
  circleColorStartGradient: ColorVariant
  circleColorEndGradient: ColorVariant
  circleColorGradientDirection: string
}

export const CompCircularProgressCore = ({
  activeIndicatorColor,
  compAlignment,
  currentValue,
  margin,
  maxValue,
  size,
  titleComponent,
  trackColor,
  labelTypography,
  textColor,
  showValue,
  valueColorType,
  valueColorSolid,
  valueColorStartGradient,
  valueColorEndGradient,
  valueColorGradientDirection,
  backgroundColor,
  circleColorType,
  circleColorSolid,
  circleColorStartGradient,
  circleColorEndGradient,
  circleColorGradientDirection,
}: CompCircularProgressProps) => {
  // Convert data to number and calculate progress
  const current = Number(currentValue) || 0
  const max = Number(maxValue) || 0
  // Calculate progress (0-1)
  const progressValue = max > 0 ? Math.min(Math.max(current / max, 0), 1) : 0
  return (
    <CircularProgress
      width={size}
      margin={margin}
      alignment={compAlignment as any}
      trackColor={`var(--color-${trackColor})`}
      fillColor={`var(--color-${activeIndicatorColor})`}
      textColor={`var(--color-on-${textColor})`}
      progress={progressValue}
      withLabel={showValue}
      thickness={10}
      typography={labelTypography}
      titleComponent={titleComponent}
      valueColorType={valueColorType}
      valueColorSolid={valueColorSolid}
      valueColorStartGradient={valueColorStartGradient}
      valueColorEndGradient={valueColorEndGradient}
      valueColorGradientDirection={valueColorGradientDirection}
      backgroundColor={backgroundColor}
      circleColorType={circleColorType}
      circleColorSolid={circleColorSolid}
      circleColorStartGradient={circleColorStartGradient}
      circleColorEndGradient={circleColorEndGradient}
      circleColorGradientDirection={circleColorGradientDirection}
    />
  )
}
